/** Grid-fade-to-screen fragment shader. */

precision highp float;

gridFade_useSamples
gridFade_useReads_fade

#ifdef gridFade_splits
  uniform sampler2D gridFade_states[gridFade_splits];
#else
  uniform sampler2D gridFade_states;
#endif

uniform float gridFade_stepNow;
uniform vec4 gridFade_stateShape;

varying vec2 gridFade_uv;

#pragma glslify: offsetUV = require(@epok.tech/gl-gpgpu/src/lookup/offset-uv);

void main() {
  vec2 uv = offsetUV(gridFade_uv, gridFade_stateShape.xy);
  // vec2 uv = gridFade_uv;

  gridFade_tapState(uv);

  vec4 to = gridFade_data[gridFade_reads_fade_fade].gridFade_channels_fade;

  gl_FragColor = to;
  gl_FragColor.rgb *= gl_FragColor.a;
}
